import Component from "../../components/ChatDetailsPage/ChatDetailsPage";
import {useContext, useEffect, useState} from "preact/hooks";
import {fetchRoomDetails, changeRoomDetails, silenceUser} from "../../api";
import {CurrentUserContext} from "../../contexts";
import {removeDiacritics} from "../../../utils";
import {NavigationContext} from "../../contexts/NavigationContext";

const ChatDetailsPage = ({roomId}) => {
  const currentUser = useContext(CurrentUserContext);
  const {route, navigate} = useContext(NavigationContext);
  const [loading, setLoading] = useState(true);
  const [room, setRoom] = useState({});
  const [query, setQuery] = useState('');

  useEffect(() => {
    (() => {
      fetchRoomDetails(roomId).then(({ data }) => {
        setRoom(data);
        setLoading(false);
      });
    })();
  }, []);

  const onChangeRestrictedUntil = (restrictedUntil) => {
    changeRoomDetails(roomId, {restrictedUntil}).then(({ data }) => {
      setRoom({...room, restrictedUntil: data.room.restrictedUntil});
    });
  };

  const onChangeMessageDisplayPeriodDays = (messageDisplayPeriodDays) => {
    changeRoomDetails(roomId, {messageDisplayPeriodDays}).then(({ data }) => {
      setRoom({...room, messageDisplayPeriodDays: data.room.messageDisplayPeriodDays});
    });
  };

  const onRequestMute = (internalId) => {
    const member = room.members.find(m => m.internalId === internalId);
    const now = new Date().toISOString();
    const isSilenced = member.timeout && member.timeout > now;
    silenceUser(currentUser.organization, member.internalId, isSilenced ? -1 : 30).then(({data}) => {
      member.timeout = data.timeout;
      setRoom({...room});
    });
  };

  const onBack = () => navigate({path: "/chat", params: route.params});

  const members = room.members ? room.members.filter(m => removeDiacritics(m.name.toUpperCase()).includes(removeDiacritics(query.toUpperCase()))) : [];

  return <Component
    onChangeRestrictedUntil={onChangeRestrictedUntil}
    onChangeMessageDisplayPeriodDays={onChangeMessageDisplayPeriodDays}
    onRequestMute={onRequestMute}
    channelName={room.channelName}
    members={members}
    restrictedUntil={room.restrictedUntil}
    messageDisplayPeriodDays={room.messageDisplayPeriodDays}
    loading={loading}
    onBack={onBack}
    query={query}
    onChangeQuery={evt => setQuery(evt.target.value)}
  />;
};

export default ChatDetailsPage;



// WEBPACK FOOTER //
// ./containers/ChatDetailsPage/ChatDetailsPage.js